import { Box } from "@mui/material";
import Footer from "components/Footer";
import PageDefaultLayout from "components/LayoutContainers/PageDefaultLayout/pageDefaultLayout";
import { setAnotherPage } from "context";
import { useMaterialUIController } from "context";
import { useEffect } from "react";
import BreadcrumbHome from "components/Navbars/HomeNavbar/breadcrumbHome";
import GioiThieu from "components/InformationOCOP";

const About = () => {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setAnotherPage(dispatch, true);
  }, []);
  return (
    <PageDefaultLayout>
      <BreadcrumbHome />
      <Box>
        <GioiThieu />
      </Box>
      <Footer isNotAbsolute={false} />
    </PageDefaultLayout>
  );
};

export default About;
